<template>
  <div>
    <table class="table is-fullwidth is-size-7 is-hoverable">
      <thead>
        <tr>
          <th v-if="showUser">{{"transactions.player" | translate}}</th>
          <th>{{"transactions.source" | translate}}</th>
          <th>{{"transactions.date" | translate}}</th>
          <th>{{"transactions.real" | translate}}</th>
          <th>{{"transactions.bonus" | translate}}</th>
          <th>{{"transactions.res real" | translate}}</th>
          <th>{{"transactions.res bonus" | translate}}</th>
          <th>{{"transactions.sum" | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="transaction in transactions" :key="transaction.id">
          <td v-if="showUser">
            <router-link :to="{ name: 'player', params: { playerId: transaction.userId } }">{{transaction.username}}</router-link>
          </td>
          <td>
            {{transaction.source}}
            <template v-if="transaction.games && transaction.games.length">
              <span class="has-text-grey" v-for="game in transaction.games">{{game.gameId}}</span>
            </template>
            <span v-if="transaction.pinInfo" class="has-text-grey">
              pin <span class="has-text-danger has-text-weight-semibold">{{transaction.pinInfo.pin}}</span>
            </span>
          </td>
          <td>
            {{transaction.date | datetime}}
          </td>
          <td :class="{'has-text-danger':transaction.type == 'Withdraw', 'has-text-success':transaction.type == 'Deposit'}">
            {{transaction.type == 'Deposit' ? '+' : '-'}}
            {{transaction.amount | currency(transaction.currency)}}
          </td>
          <td :class="{'has-text-danger':transaction.type == 'Withdraw', 'has-text-success':transaction.type == 'Deposit'}">
            {{transaction.type == 'Deposit' ? '+' : '-'}}
            {{transaction.bonus | currency(transaction.currency)}}
          </td>
          <td class="has-text-weight-semibold">
            {{transaction.balanceAfter | currency(transaction.currency)}}
          </td>
          <td class="has-text-weight-semibold">
            {{transaction.bonusAfter | currency(transaction.currency)}}
          </td>
          <td class="has-text-weight-semibold">
            {{transaction.balanceAfter + transaction.bonusAfter | currency(transaction.currency)}}
          </td>
        </tr>
      </tbody>
    </table>
    <pagination @change="loadTransactions();" ref="pagination" :page-size="100" />
  </div>
</template>

<script>
  import pagination from './pagination.vue'

  export default {
    name: 'transactions-list',
    components: { pagination },
    props: {
      dataFunc: {
        type: Function,
        required: true
      },
      showUser: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        transactions: []
      }
    },
    async mounted() {
      await this.loadTransactions();
    },
    methods: {
      async reset() {
        await this.loadTransactions(0);
      },
      async loadTransactions(page) {
        const filter = {
          pageNumber: page || this.$refs.pagination.pageNumber,
          pageSize: this.$refs.pagination.pageSize
        };
        const data = await this.dataFunc(filter);
        this.transactions = data.items;
        this.$refs.pagination.set(data.pageNumber, data.totalPages);
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/transactions-list.vue